import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const signInHeaderStyles = makeStyles({
  main: {
    width: "100%",
    position: "sticky",
    top: "0px",
    zIndex: "1",
  },
  bar: {
    display: "flex",
    alignItems: "center",
    flexShrink: "0",
    justifyContent: "space-between",
    backgroundColor: tokens.colorNeutralBackground2,
    boxShadow: "0px 2.63px 7.02px 0px #0000003D",
    minHeight: "48px",
    ...shorthands.borderRadius("0px"),
    borderBottom: "var(--Small, 2px) solid var(--AAA, #464FEB)",

    "@media (max-width: 540px)": {
      boxShadow: tokens.shadow2,
    },
  },
  button: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    padding: "8px 16px",
  },
});
